export default "__VITE_ASSET__C_YXfT4S__"